import { action, makeObservable, observable } from 'mobx'

import { MEDIUM_DESKTOP_SCREEN_IN_PIXELS } from '@avantstay/backoffice-core'

class _UiStore {
  // ------------ Observables
  isSideBarOpened = observable.box(window.outerWidth >= MEDIUM_DESKTOP_SCREEN_IN_PIXELS)

  shouldDisplaySideBar = true

  shouldDisplayFilterSidebar = false

  shouldExpandAllFilterSidebarItems?: boolean = undefined

  // -------- actions
  setIsSidebarOpened = (value: boolean) => {
    this.isSideBarOpened.set(value)
  }

  setShouldDisplaySideBar = (value: boolean) => {
    this.shouldDisplaySideBar = value
  }

  setShouldDisplayFilterSideBar = (value: boolean) => {
    if (!value) this.shouldExpandAllFilterSidebarItems = false
    this.shouldDisplayFilterSidebar = value
  }

  toggleExpandAllFilterSideBarItems = () => {
    this.shouldExpandAllFilterSidebarItems = !this.shouldExpandAllFilterSidebarItems
  }

  constructor() {
    makeObservable(this, {
      shouldDisplaySideBar: observable,
      shouldDisplayFilterSidebar: observable,
      shouldExpandAllFilterSidebarItems: observable,
      setShouldDisplaySideBar: action.bound,
      setShouldDisplayFilterSideBar: action.bound,
      toggleExpandAllFilterSideBarItems: action.bound,
    })
  }
}

export const UiStore = new _UiStore()
